import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { Login } from '@itds/components/index.js';

import { RECAPTCHA_SITE_KEY } from '@/config';

import Api from '@brokerage/utils/Api';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (Cookies.get('control-room-b')) {
      navigate('/agencies');
    }
  });

  const login = data => {
    setLoading(true);

    Api.login(data)
      .then(({ headers }) => {
        Cookies.set('control-room-b', headers['access-token']);
        Cookies.set('control-room-br', headers['refresh-token']);

        window.location.reload();
      })
      .catch(() => {
        setError('Invalid email or password.');
        setLoading(false);
      });
  };

  return (
    <Login
      error={error}
      loading={loading}
      onLogin={login}
      siteKey={RECAPTCHA_SITE_KEY}
      title='Brokerage Admin'
    />
  );
};

export default AdminLogin;
